import { useState, useRef, useEffect } from "react";
import {
  FiBold,
  FiItalic,
  FiUnderline,
  FiAlignLeft,
  FiAlignCenter,
  FiAlignRight,
  FiList,
  FiType,
} from "react-icons/fi";

export default function RichTextEditor({
  content,
  onChange,
  readOnly = false,
}) {
  const editorRef = useRef(null);
  const [htmlContent, setHtmlContent] = useState(content || "");

  useEffect(() => {
    if (editorRef.current && content !== undefined) {
      const currentContent = editorRef.current.innerHTML;
      if (currentContent !== content) {
        editorRef.current.innerHTML = content || "";
      }
    }
  }, [content]);

  const handleInput = () => {
    if (editorRef.current) {
      const newContent = editorRef.current.innerHTML;
      setHtmlContent(newContent);
      if (onChange) {
        onChange(newContent);
      }
    }
  };

  const execCommand = (command, value = null) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
    handleInput();
  };

  const ToolbarButton = ({ icon: Icon, command, value, title }) => (
    <button
      type="button"
      onClick={() => execCommand(command, value)}
      className="p-2 hover:bg-gray-200 dark:hover:bg-gray-700 rounded transition-colors"
      title={title}
      disabled={readOnly}
    >
      <Icon className="w-4 h-4" />
    </button>
  );

  return (
    <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden bg-white dark:bg-gray-800 flex flex-col h-full max-h-full">
      {!readOnly && (
        <div className="flex  gap-1 p-2  border-b border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-900 flex-shrink-0">
          <ToolbarButton icon={FiBold} command="bold" title="Bold" />
          <ToolbarButton icon={FiItalic} command="italic" title="Italic" />
          <ToolbarButton
            icon={FiUnderline}
            command="underline"
            title="Underline"
          />
          <div className="w-px bg-gray-300 dark:bg-gray-600 mx-1" />
          <ToolbarButton
            icon={FiAlignLeft}
            command="justifyLeft"
            title="Align Left"
          />
          <ToolbarButton
            icon={FiAlignCenter}
            command="justifyCenter"
            title="Align Center"
          />
          <ToolbarButton
            icon={FiAlignRight}
            command="justifyRight"
            title="Align Right"
          />
          {/* <div className="w-px bg-gray-300 dark:bg-gray-600 mx-1" />
          <ToolbarButton
            icon={FiList}
            command="insertUnorderedList"
            title="Bullet List"
          />
          <ToolbarButton
            icon={FiType}
            command="formatBlock"
            value="<h1>"
            title="Heading"
          /> */}
        </div>
      )}
      <div
        ref={editorRef}
        contentEditable={!readOnly}
        onInput={handleInput}
        className="flex-1 p-4 overflow-y-auto focus:outline-none text-gray-900 dark:text-white prose dark:prose-invert max-w-none min-h-0"
        style={{
          wordBreak: "break-word",
        }}
      />
    </div>
  );
}
